import React, { useEffect, useState } from 'react';
import { Grid, ButtonGroup, Button } from '@mui/material';
import { useDispatch } from 'react-redux';
import { setlayoutLiveTracking } from '../../features/layout/layoutSlice';

import LockUnlockModal from './LockUnlockModal';
const SecurityViewFooter = ({ securityData, assetId }) => {
    const dispatch = useDispatch();
    useEffect(() => {
        const liveTrackingLayoutPayload = {
            sidebarWidthratio: 0.25,
            minFooter: 80,
        };
        dispatch(setlayoutLiveTracking(liveTrackingLayoutPayload));
        //console.log("re rendering");
    }, [dispatch]);

    const [lockModalOpen, setLockModalOpen] = useState(false);
    const [usercmd, setUsercmd] = useState(null);
    const [lockInput, setLockInput] = useState(null);
    const [cmdName, setCmdName] = useState(null);
    const handleLockModalClose = () => {
        setLockModalOpen(false);
        setUsercmd(null);
    }

    const handleLockUnlock = (name, action) => {
        let lockip;
        if (name.toLowerCase().indexOf('engine') !== -1) {

            lockip = 1;
        } else {
            lockip = 2;
        }
        setCmdName(name);
        setUsercmd(action);
        setLockInput(lockip);
        setLockModalOpen(true);
    }

    return (
        <Grid
            container
            direction='row'
            justifyContent='flex-start'
            alignItems='center'
            alignContent="center"
            wrap='wrap'
            spacing={1}
            style={{
                marginLeft: '0px',
                marginBottom: '10px',
                width: '90vw',
            }}
        >
            {
                securityData && Object.keys(securityData).map(name =>
                    <Grid item key={name}>
                        <ButtonGroup>
                            <Button
                                variant="contained"
                                color="secondary"
                                size="small"
                            >
                                {name}
                            </Button>
                            <Button
                                variant="outlined"
                                size="small"
                                style={{
                                    color: 'blueGray',
                                }}
                            >
                                <span><b>{`${securityData[name]}`}</b></span>
                            </Button>
                            {
                                securityData[name].toLowerCase() === 'unlocked' &&
                                <Button
                                    variant="contained"
                                    style={{
                                        backgroundColor: 'Crimson',
                                        color: 'White',
                                    }}
                                    size="small"
                                    onClick={() => handleLockUnlock(name, 'lock')}
                                >
                                    Lock
                                </Button>

                            }
                            {
                                securityData[name].toLowerCase() === 'locked' &&
                                <Button
                                    variant="contained"
                                    style={{
                                        backgroundColor: 'ForestGreen',
                                        color: 'White',
                                    }}
                                    size="small"
                                    onClick={() => handleLockUnlock(name, 'unlock')}
                                >
                                    Unlock
                                </Button>

                            }
                            {
                                securityData[name].toLowerCase() !== 'unlocked' && securityData[name].toLowerCase() !== 'locked' &&
                                <Button
                                    variant="contained"
                                    style={{
                                        backgroundColor: 'Gray',
                                        color: 'White',
                                    }}
                                    size="small"
                                >
                                    Sensor Settings Wrong
                                </Button>
                            }

                        </ButtonGroup>
                    </Grid>
                )
            }
            <LockUnlockModal
                assetId={assetId}
                cmdName={cmdName}
                usercmd={usercmd}
                lockInput={lockInput}
                lockModalOpen={lockModalOpen}
                handleLockModalClose={handleLockModalClose}
            />
        </Grid>
    );
}

export default React.memo(SecurityViewFooter);